import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  show: false,
  inactivityShow: false
};

const TimeOutAlertSlice = createSlice({
  name: 'timeOutAlert',
  initialState,
  reducers: {
    showTimeOutAlert: (state) => {
      state.show = true;
    },
    closeTimeOutAlert: (state) => {
        state.show = false;
        state.inactivityShow = false;
    },
    showInactivityAlert: (state) => {
      state.inactivityShow = true;
    },
  },
});

export const { showTimeOutAlert, closeTimeOutAlert, showInactivityAlert } = TimeOutAlertSlice.actions;
export default TimeOutAlertSlice.reducer;
